/** UI-Einstiegspunkt: App rendern + Session beim Laden prüfen. */

import { render } from "preact";
import { App } from "./app";
import { bootstrap } from "./store";

const root = document.getElementById("app");
if (root) render(<App />, root);

void bootstrap();
